export enum ActionTypes {
  LOAD_ALERT_REQUEST = "LOAD_ALERT_REQUEST",
  LOAD_ALERT_SUCCEEDED = "LOAD_ALERT_SUCCEEDED",
  LOAD_ALERT_FAILED = "LOAD_ALERT_FAILED",
}

export default ActionTypes;
